import React from 'react';
import { Box, Stack, Typography } from '@mui/material';
import { palette, radius, shadow, typography } from './designTokens';

// Note: header padding is intentionally fixed and decoupled from body padding,
// so callers can pass padding={0} or noPadBody to flush body content (tables,
// lists) against the card edges without losing the header padding.
const HEADER_PX = 2.5;
const HEADER_PY = 1.75;

const SectionCard = ({
  title,
  subtitle,
  actions,
  children,
  padding = 2.5,
  noPadBody = false,
  sx = {},
  // The body is a box of its own, so a card told to fill a fixed height can
  // still only stretch its border — the content inside stays its natural size
  // and either falls short or overflows. This is the handle on that inner box,
  // for the callers that size themselves against the viewport.
  bodySx = {},
}) => {
  return (
    <Box
      sx={{
        bgcolor: palette.surface,
        borderRadius: `${radius.md}px`,
        border: `1px solid ${palette.line}`,
        boxShadow: shadow.card,
        overflow: 'hidden',
        ...sx,
      }}
    >
      {(title || actions) && (
        <Stack
          direction="row"
          alignItems="center"
          justifyContent="space-between"
          spacing={2}
          sx={{
            px: HEADER_PX,
            py: HEADER_PY,
            borderBottom: `1px solid ${palette.line}`,
          }}
        >
          {/* minWidth: 0 lets the long subtitle wrap instead of forcing the row
              wider and squeezing the actions. Without it a flex item refuses to
              shrink below its content, which is what deformed the button. */}
          <Box sx={{ minWidth: 0 }}>
            {title && <Typography sx={typography.sectionTitle}>{title}</Typography>}
            {subtitle && (
              <Typography sx={{ ...typography.caption, mt: 0.25 }}>{subtitle}</Typography>
            )}
          </Box>
          {actions && (
            <Stack direction="row" spacing={1} alignItems="center" sx={{ flexShrink: 0 }}>
              {actions}
            </Stack>
          )}
        </Stack>
      )}
      <Box sx={{ p: noPadBody ? 0 : padding, ...bodySx }}>{children}</Box>
    </Box>
  );
};

export default SectionCard;
